const reports = {
  exportPdf: 'Exportar PDF',
  generatedBy: 'Generado por SpeedGauge Coach AI',
  exportDescription: 'Exportar respuesta de Coach AI como PDF',
  exportingPdf: 'Exportando PDF',
  exportFailed: 'La exportación de PDF falló',
  loadingMap: 'Cargando mapa...',
  generatedAt: 'PDF {{timestamp}}',
  dataSources: 'Fuentes de datos',
  staticMapCaption: 'Captura estática del mapa obtenida de la vista del mapa del chat.',
  audit: {
    customer: 'Cliente',
    customerId: 'ID de cliente',
    vehicleGroup: 'Grupo de vehículos',
    vehicleGroupId: 'ID del grupo de vehículos',
    user: 'Usuario',
    sessionId: 'ID de sesión',
    messageId: 'ID de mensaje',
    messageTimestamp: 'Marca de tiempo del mensaje',
  },
  pdf: {
    confidential: '- CONFIDENCIAL -',
    verificationDisclaimer: 'Los resultados pueden requerir revisión y verificación',
    page: 'Página {{page}} de {{total}}',
  },
  map: {
    location: 'Ubicación',
    title: 'Mapa',
    snapshot: 'Captura de mapa',
    speedLimitLookup: 'Consulta de límite de velocidad ({{coordinates}})',
    speedZone: '{{speed}} {{unit}} en zona de {{limit}} {{unit}} (+{{difference}})',
    speedLimit: '{{speed}} {{unit}} (límite {{limit}}, +{{difference}})',
    incident: 'Incidente',
  },
} as const;

export default reports;